// Copyright (c) 2017 Deere & Company

import DealerInvoiceContainer from '../../claim/dealer-invoices/state-connector';

export default {
    component: DealerInvoiceContainer,
    name: 'DEALER_INVOICES',
    path: 'dealer-invoices'
};



// WEBPACK FOOTER //
// ./src/routes/claims/dealer-invoice.js